<template lang="html">
  <div class="step2">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content row">
        <div class="ibox-title col-sm-12">
          <h5 class="text-center">会员登记申请</h5>
        </div>
        <div class="box col-sm-12 row">
          <div class="row">
            <div class="col-sm-12">
              <h5 class="sub-tit"><span class="red">*</span>主要艺术成就及获奖情况：</h5>
            </div>
          </div>
          <div class="col-sm-11" style="padding:5px;overflow-x:auto;">
            <table class="table border">
              <thead class="">
                <tr scope="row">
                  <th scope="col">时间</th>
                  <th scope="col">地点</th>
                  <th scope="col">主办单位</th>
                  <th scope="col">著作出版社</th>
                  <th scope="col">作品或获奖情况</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <step-second v-on:getRemoveIndex="catchRemoveIndex" v-bind:index="index" v-on:getFormData="catchFormData"
                  v-for="(item, index) in inputGroup" :key="index"></step-second>
              </tbody>
            </table>
          </div>
          <div class="col-sm-1">
            <div class="btn btn-secondary" @click="addHtml">
              增加
            </div>
          </div>
          <div class="row col-sm-12 upload-image">
            <div class="col-sm-auto " v-if="!avatar.length">
              <div class="example-img fixedWidth">
              </div>
            </div>
            <div class="col-sm-auto" v-if="avatar.length" v-for="(item, index) in avatar" :key="index">
              <div class="example-img position-relative">
                <img :src="item" alt="">
                <span class="delPhoto" @click="removePhoto(index)">×</span>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="customFile" @change="uploadImage">
                <label class="custom-file-label" for="customFile"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="form-group" style="margin: 0 auto;">
        <div class="btn btn-primary" @click="goNextStep">
          提交审核
        </div>
      </div>
    </div>
    <loading-model v-bind:show="isLoading"></loading-model>
    <alert-model v-bind:show="alertShow" v-on:close="catchClose" v-bind:msg="tips"></alert-model>
  </div>
</template>

<script>
import Vue from 'vue'
import commonHeader from './header.vue'
import stepSecond from './step2.vue'
import loadingModel from './loading.vue'
import alertModel from './alert.vue'
export default {
  data() {
    return {
      isLoading: false,
      inputGroup: [1],
      count: 1,
      formData: [],
      avatar: [],
      id: '',
      alertShow: false,
      tips: ''
    }
  },
  components: {
    commonHeader,
    stepSecond,
    loadingModel,
    alertModel
  },
  methods: {
    catchRemoveIndex(index) {
      this.inputGroup.splice(index, 1)
    },
    removePhoto(index) {
      this.avatar.splice(index, 1)
    },
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      this.alertShow = true
      this.tips = msg
      if (typeof func === 'function') {
        func()
      }
    },
    addHtml() {
      this.count++
      this.inputGroup.push(this.count)
    },
    catchFormData(data) {
      this.formData[data.index] = (data.formData[data.index])
    },
    goNextStep() {
      let formData = []
      for (let i = 0; i < this.formData.length; i++) {
        formData.push(this.formData[i])
      }
      let config = {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
      let photo = this.avatar.join(',')
      this.$axios.post("/api/wenlian/step2", { data: formData, photos: photo, request_id: this.id }, config).then(res => {
        if (res.data.result == 1) {
          this.alert('提交成功', () => {
            this.$router.push('/')
          })
          //this.$router.push({ path: '/applyStep3', query: { id: res.data.request_id } })
        } else {
          alert(res.data.msg)
        }

      })
    },
    uploadImage(e) {
      this.loading = true
      let that = this
      let img = e.target.files[0];
      let param = new FormData()
      param.append('file', img)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$axios.post('/api/wenlian/upload', param, config)
        .then(res => {
          this.loading = false
          if (res.data.result === 1) {
            this.avatar.push(res.data.url)
            this.alert(res.data.msg)
          } else {
            this.alert(res.data.msg)
          }
        })
    }
  },
  mounted() {
    console.log(this.$route)
    this.id = this.$route.query.id

  }
}
</script>

<style lang="css" scoped>
.step2 .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

.step2 .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}

.step2 .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}

.step2 .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

.step2 .btn-secondary {
  margin-top: 10px;
}

.step2 .part {
  padding: 20px 0;
}

.step2 .border {
  width: 100%;
}

.step2 .fullScreen {
  height: 100%;
}

.step2 .page-link {
  color: #33434b;
}

.step2 .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}

.step2 .page-link.active {
  background: #f4f4f4;
}

.step2 .custom-file-label::after {
  content: "证明材料上传";
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}

.step2 .custom-file-label {
  border: none;
}

.step2 .red {
  color: red;
  margin: 0 5px;
}

.step2 .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
}

.step2 table td,
table th {
  color: #333;
}

.step2 .table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}

.step2 .form-group {
  margin-bottom: 0;
}

.step2 .upload-image {
  margin-top: 20px;
}

.step2 .upload-image img {
  height: 150px;
  width: auto;
}

.step2 .custom-file {
  margin-top: 0%;
}

.step2 .example-img {
  height: 150px;
  min-width: 50px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  position: relative;
  display: flex;
  justify-content: center;
}

.step2 .fixedWidth {
  width: 200px;
}

.step2 .example-img>img {
  position: relative;
  z-index: 999;
}

.step2 .example-img:after {
  content: "+";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #33434b;
  font-size: 50px;
}

.step2 .row {
  margin-left: 0;
  margin-right: 0;
}

.delPhoto {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 999;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #f31a1a;
  color: #fff;
  line-height: 22px;
  text-align: center;
  font-size: 25px;
}

@media screen and (max-width: 750px) {
  .table {
    width: 1400px !important;
  }

  .table thead tr th:first-child {
    width: 500px !important;
  }

  .step2 .example-img {
    margin: 0 auto 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applyStep2.vue